// API Configuration
const getApiUrl = () => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Otherwise, auto-detect based on current URL
  const hostname = window.location.hostname;
  
  // The production app is same-origin behind Nginx. Only local development
  // talks directly to the backend port.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}:3001`;
  }
  
  return '';
};

const config = {
  // Backend API URL - automatically detects or uses env variable
  API_URL: getApiUrl(),
  
  // Spotify Web Playback SDK settings
  PLAYER_NAME: "Tom's Jukebox",
  
  // UI Settings
  SEARCH_DEBOUNCE_MS: 500,
  AUTO_HIDE_CONTROLS_MS: 10000,
};

export default config;
